module.exports = __webpack_public_path__ + "img/pagsmile.23546cd.svg";